import { View } from 'react-native'
import styled from 'styled-components'
import { media } from '../../../style/media'

export const PlansPromoList = styled(View)`
  align-self: center;
  ${media.sm`
    flex-direction: row;
  `}
`
